/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Compat_1Inputs */

const en_pc_online_compat_1 = /** @type {(inputs: Pc_Online_Compat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs WebGL2, which current Chrome, Edge, Firefox and Safari all support. The 0.8.0 web build draws its interface with WebGL.`)
};

const zh_pc_online_compat_1 = /** @type {(inputs: Pc_Online_Compat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要 WebGL2，新版 Chrome、Edge、Firefox 和 Safari 都支持。0.8.0 网页版使用 WebGL 绘制界面。`)
};

/**
* | output |
* | --- |
* | "Needs WebGL2, which current Chrome, Edge, Firefox and Safari all support. The 0.8.0 web build draws its interface with WebGL." |
*
* @param {Pc_Online_Compat_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_compat_1 = /** @type {((inputs?: Pc_Online_Compat_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Compat_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_compat_1(inputs)
	return zh_pc_online_compat_1(inputs)
});
export { pc_online_compat_1 as "pc.online.compat.1" }